import styled from 'styled-components';
import { color } from 'theme';
import {
    GREY_200, GREY_300, GREY_400, PURPLE_100, PURPLE_500, RED_500,
} from '../../../../constants';

export const DomainCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 0.5rem;
    box-shadow: 0 0 1px 1px ${color('border.divider')};
    overflow: hidden;
`;

export const DomainCardHeader = styled.button`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.875rem 1rem;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    width: 100%;

    &:hover {
        background: ${color('background.secondary')};
    }
`;

export const DomainIconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.375rem;
    height: 2.375rem;
    border-radius: 50%;
    background: ${PURPLE_100};
    color: ${PURPLE_500};
    flex-shrink: 0;

    svg {
        width: 1.125rem;
        height: 1.125rem;
    }
`;

export const DomainInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    flex: 1;
    overflow: hidden;
    min-width: 0;
`;

export const DomainTitle = styled.span`
    font-size: 0.9375rem;
    font-weight: 500;
    color: ${GREY_400};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const DomainSubtitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.125rem;
`;

export const DomainSubtitle = styled.span`
    font-size: 0.8125rem;
    font-weight: 300;
    color: ${GREY_300};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const UserCountText = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.8125rem;
    font-weight: 300;
    color: ${GREY_300};
    white-space: nowrap;

    svg {
        width: 0.875rem;
        height: 0.875rem;
        flex-shrink: 0;
    }
`;

export const SubtitleSeparator = styled.span`
    font-size: 0.8125rem;
    font-weight: 300;
    color: ${GREY_200};
    user-select: none;
    margin: 0 0.25rem;
`;

export const WorkflowNameText = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.8125rem;
    font-weight: 300;
    color: ${GREY_300};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 12rem;

    svg {
        width: 0.875rem;
        height: 0.875rem;
        flex-shrink: 0;
    }
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    flex-shrink: 0;
`;

export const ChevronIcon = styled.span<{ $isExpanded: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${GREY_200};
    transition: transform 0.2s ease;
    transform: ${({ $isExpanded }) => ($isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
    flex-shrink: 0;

    svg {
        width: 1.125rem;
        height: 1.125rem;
    }
`;

export const DomainCardBody = styled.div`
    display: flex;
    flex-direction: column;
    border-top: 1px solid ${color('border.divider')};
    padding: 0.25rem 0;
    background: ${color('background.secondary')};
`;

export const NoWorkflowWarning = styled.span`
    display: inline-flex;
    align-items: center;
    font-size: 0.8125rem;
    font-weight: 400;
    color: ${RED_500};
    white-space: nowrap;
`;

export const EmptyUsersMessage = styled.p`
    padding: 1.25rem 1rem;
    font-size: 0.875rem;
    font-weight: 300;
    color: ${GREY_300};
    text-align: center;
`;
